import { render } from "./HosPalReferralDocuments.vue?vue&type=template&id=62e61176&ts=true"
import script from "./HosPalReferralDocuments.ts?vue&type=script&lang=ts&external"
export * from "./HosPalReferralDocuments.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__